import { render, staticRenderFns } from "./logisticsAddress.vue?vue&type=template&id=0f98580d&scoped=true&"
import script from "./logisticsAddress.vue?vue&type=script&lang=js&"
export * from "./logisticsAddress.vue?vue&type=script&lang=js&"
import style0 from "./logisticsAddress.vue?vue&type=style&index=0&id=0f98580d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f98580d",
  null
  
)

export default component.exports